import { IReportCallDataRequest } from "../../types/api/calls";
import { IReportCallData } from "../../types/call";

export const toBackendReportCallData = (
  data: IReportCallData
): IReportCallDataRequest => {
  const trimmedTopic = data.topic.trim();
  const trimmedDescription = data.description?.trim();

  const result: IReportCallDataRequest = {
    topic: trimmedTopic,
  };
  if (trimmedDescription) {
    result.description = trimmedDescription;
  }
  return result;
};
